export interface UniqueDocumentoValidationErrorProps {
  value: string;
}

export class UniqueDocumentoValidationError {
  constructor(public value: string) {}
}
